import React, { useRef } from 'react'
import Navbar from './Navbar'
import "../Styles/MachineLog.css"
import { getUserDetails, getSensorLog, getSensorOnTime } from "../Utility/AsyncStorageData";
import axios from "axios";

import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "./Modal";
import Report from '../Utility/Report'
import Header from "./Header";
import { useNavigate } from 'react-router-dom';

import { Dots } from "react-activity";
import "react-activity/dist/library.css";
import { showToast } from './Toast';

function MachineLogs() {
    var userDetails = getUserDetails();
    var Logs = getSensorLog();
    let navigate = useNavigate();
    // console.log(Logs)

    const shiftValue = React.useRef(undefined);
    const prodCategoryList = useRef([])

    const date1 = React.useRef(moment().format("YYYY-MM-DD"));
    const [date, setDate] = React.useState(date1.current);
    const [shiftTime, setShiftTime] = React.useState();
    const [options, setOptions] = React.useState([]);
    const [productoptions, setProductoptions] = React.useState([]);
    // const [prodCategoryList.current, setprodCategoryList.current] = React.useState([]);
    const [prodCategory, setProdCategory] = React.useState("");

    const [On_Time, setOn_Time] = React.useState(getSensorOnTime())
    const [from, setFrom] = React.useState()
    const [to, setTo] = React.useState()
    const [List, setList] = React.useState(1);
    const [hourData, setHourData] = React.useState([])
    const [machineHalts, setMachineHalt] = React.useState([])
    const [machineFreeHalts, setMachineFreeHalt] = React.useState([])
    const [open, setOpen] = React.useState(false);
    const [test, setTest] = React.useState(1);

    const [reasonLoading, setReasonLoading] = React.useState(false);

    const [reasonList, setReasonList] = React.useState([])
    const [product, setProduct] = React.useState({})
    const [productWiseLog, setProductWiseLog] = React.useState([])
    const [shiftChangeFlag, setShiftChangeFlag] = React.useState(false)

    const backColor = (effi, alarm_color) => {
        // console.log(effi, alarm_color)
        if (alarm_color) {
            if (effi >= alarm_color.Y) {
                return "#F1F9EE" //green
            }
            else if (effi >= alarm_color.R) {
                return "#FEFBED" // orange
            }
            else {
                return "#FBF3F3" // red
            }
        }
        else {
            return ("#D3D3D3") //gray
        }
    }

    const handleChange = (event) => {
        setShiftTime(event.target.value)
        let item = options.find(item => item.value == event.target.value);
        const [from1, to1] = item.label.split(' - ');

        setFrom(value => from1)
        setTo(value => to1)
        shiftValue.current = event.target.value
        machineHours()
        machineTime()
    }

    const handleDateChange = (changedDate) => {
        setDate(moment(changedDate).format('YYYY-MM-DD'))
        date1.current = changedDate
        setShiftChangeFlag(true)
        // console.log("Date changed to:", moment(changedDate).format('YYYY-MM-DD'));
        // machine_Data()
        machineHours()
        machineTime()
        productWiseLogList()
    };

    const machine_Data = async () => {
        try {

            let url = process.env.REACT_APP_BASE_URL + '/shift/fetchShiftList';
            let body = {
                machine_id: Logs.machine_id,
                cDate: moment(date1.current).format("YYYY-MM-DD")
            };

            // console.log('*********************** fetchShiftList**************', body);
            await axios
                .post(url, body, {
                    headers: {
                        authorization: `${userDetails.access_token}`,
                    },
                })
                .then(response => {
                    if (response.status === 200) {

                        if (response.data.statusCode == 0) {
                            // console.log(' machine shift response', response.data);

                            const transformedArray = response.data.list.map(item => ({
                                label: item.shift_name,
                                value: String(item.shift_id)
                            }));
                            setOptions(transformedArray);

                            var desiredShift = 0;
                            if (response.data.curShift == 0) {
                                desiredShift = response.data.list[0].shift_id
                            }
                            else {
                                desiredShift = response.data.list.find(shift => shift.shift_id == response.data.curShift);
                                desiredShift = desiredShift.shift_id
                            }

                            if (desiredShift) {
                                setFrom(desiredShift.start_time)
                                setTo(desiredShift.end_time)
                                shiftValue.current = String(desiredShift)
                            }


                        }
                        else {
                            showToast(response.data.msg, 3000, "red");
                            return;
                        }

                    }

                    else if (response.status === 403) {
                        navigate("/");
                    }

                })
                .catch(error => {
                    {
                        // navigate("/");
                    }
                    console.log(error)
                    showToast("Error", 3000, "red");
                    return;
                });
        } catch (error) {
            console.log('error ', error);
            throw error;
        }
    };

    const machineHours = async () => {
        try {
            // console.log('*********** fetchHourList ***********');


            let url = process.env.REACT_APP_BASE_URL + '/shift/fetchHourList';
            let body = {
                machine_id: Logs.machine_id,
                shift_id: shiftValue.current ?? undefined,
                cDate: moment(date1.current).format("YYYY-MM-DD")
            };

            // console.log(' machineHours body', body);
            await axios
                .post(url, body, {
                    headers: {
                        authorization: `${userDetails.access_token}`,
                    },
                })
                .then(response => {
                    if (response.status === 200) {

                        if (response.data.statusCode === 0) {
                            // console.log("machineHours", response.data.hourList)
                            setHourData(response.data.hourList)
                            setMachineHalt(response.data.stopList)
                            setMachineFreeHalt(response.data.freeLoadList)
                        }
                        else {
                            // console.log("fetchHourList error", response.data.msg)

                            showToast(response.data.msg, 3000, "red");
                            return;
                        }

                    }
                })
                .catch(error => {
                    if (error.response.status == 403) {
                        navigate("/");
                    }

                    showToast("Error", 3000, "red");
                    // return;
                });

        } catch (error) {
            console.log('error ', error);
            throw error;
        }

    };

    const handleproductList = async (category) => {
        try {

            var type = ""
            if (category) {
                const selectedCategory = prodCategoryList.current.find(option => option.id == category);
                type = selectedCategory.product_type
            }
            else {
                type = undefined
            }


            let url = process.env.REACT_APP_BASE_URL + "/ws/listProductPart";
            let body = {
                comp_num: userDetails.comp_num,
                machine_id: Logs.machine_id,
                product_type: type
            }
            console.log("************handleproductList************ ", body, prodCategory)
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        console.log("************companyWiseDeviceList************ ", response.data)
                        setProductoptions(response.data.list)

                    }
                    else if (response.data.statusCode === 1) {
                        // showToast(response.data.msg, 3000, "red");
                    }


                    else {

                        showToast(response.data.msg, 3000, "red");
                        console.log(" companyWiseDeviceList error: ", response.data.msg);
                    }

                    // setLoading (false);
                }


                else if (response.status == 403) {
                    navigate("/");
                }

            }).catch(error => {
                console.log("error: ", error);
                showToast("Slow or no internet connected. Please check your internet connection.", 3000, "red");

                // Alert.alert("ERROR")

                return
            })
        } catch (error) {
            console.log("error1 ", error)
            showToast(error, 3000, "red");
            return
        }
    }

    const machineTime = async () => {
        try {
            // console.log('*********** fetchHourList ***********');


            let url = process.env.REACT_APP_BASE_URL + '/shift/fetchShiftWiseData';
            let body = {
                machine_id: Logs.machine_id,
                shift_id: shiftValue.current ?? undefined,
                cDate: moment(date1.current).format("YYYY-MM-DD")
            };

            // console.log(' machineHours body', body);
            await axios
                .post(url, body, {
                    headers: {
                        authorization: `${userDetails.access_token}`,
                    },
                })
                .then(response => {
                    if (response.status === 200) {

                        if (response.data.statusCode === 0) {
                            // console.log("machineHours", response.data.result)
                            setOn_Time({
                                efficiency: response.data.result[0].efficiency.toFixed(0),
                                on_time: response.data.result[0].on_time,
                                Idproduct: response.data.result[0].machineTime_Id,
                                product: response.data.result[0].product_part,
                                sensor_count: response.data.result[0].sensor_count,
                                counter_flag: On_Time.counter_flag,
                                counter_unit: On_Time.counter_unit
                            })
                            // console.log("ontime ", {
                            //     efficiency: response.data.result[0].efficiency.toFixed(2),
                            //     on_time: response.data.result[0].on_time,
                            //     Idproduct: response.data.result[0].machineTime_Id,
                            //     product: response.data.result[0].product_part,
                            //     sensor_count: response.data.result[0].sensor_count,

                            // })

                        }
                        else {
                            console.log("fetchHourList error", response.data.msg)
                            showToast(response.data.msg, 3000, "red");
                            return;
                        }

                    }
                })
                .catch(error => {
                    if (error.response.status == 403) {
                        navigate("/");
                    }

                    showToast("Error", 3000, "red");
                    // return;
                });

        } catch (error) {
            console.log('error ', error);
            throw error;
        }
    }

    const updateProduct = async (updatedproduct) => {
        try {

            let url = process.env.REACT_APP_BASE_URL + '/shift/insertMachineProductPart';
            let body = {
                product_name: updatedproduct.part,
                machine_id: Logs.machine_id,
                product_type: prodCategoryList.current.find(option => option.id == prodCategory).product_type
            };

            console.log(' machineHours body', body, product);
            await axios
                .post(url, body, {
                    headers: {
                        authorization: `${userDetails.access_token}`,
                    },
                })
                .then(response => {
                    if (response.status === 200) {

                        if (response.data.statusCode === 0) {
                            console.log("machineHours", response.data)
                            showToast(response.data.msg, 3000, "green");
                        }
                        else {
                            console.log("fetchHourList error", response.data.msg)

                            showToast(response.data.msg, 3000, "red");
                        }

                    }
                })
                .catch(error => {
                    if (error.response.status == 403) {
                        navigate("/");
                    }

                    showToast("Error", 3000, "red");
                    // return;
                });

        } catch (error) {
            console.log('error ', error);
            throw error;
        }
        productWiseLogList();
    }

    const handleProduct = (product) => {
        const { value } = product.target;
        let temp = productoptions.find((part) => part.id == value);
        const newProduct = { part: temp.part };
        setProduct(newProduct);
        updateProduct(newProduct);
    };

    const updateHaltReason = async (index, halt_reason) => {
        try {

            let url = process.env.REACT_APP_BASE_URL + '/shift/updateMachineHaltReason';
            let body = {
                halt_id: index,
                halt_reason: halt_reason
            };
            await axios
                .post(url, body, {
                    headers: {
                        authorization: `${userDetails.access_token}`,
                    },
                })
                .then(response => {
                    if (response.status === 200) {

                        if (response.data.statusCode == 0) {
                            machineHours()
                            setReasonLoading(false)
                            // run_toast(response.data.msg, "success")
                            // setLoading(false)
                        }
                        else {
                            // console.log(' fetchShiftList error', response.data.msg);
                            // run_toast(response.data.msg, "warning")
                            // setLoading(false)
                        }
                    }

                })
                .catch(error => {
                    // console.log('fetchShiftList error ', error);
                    // run_toast(error, "warning")
                    // setLoading(false)
                });
        } catch (error) {
            // console.log('error ', error);
            throw error;
        }
        setReasonLoading(false)


    };

    const handleReason = (index, halt_reason) => {
        const { name, value } = halt_reason.target;
        setReasonLoading(true)
        updateHaltReason(index, value);
    };

    const handleReasonList = async () => {
        try {

            let url = process.env.REACT_APP_BASE_URL + "/shift/machineHaltReason";
            let body = {
                comp_num: userDetails.comp_num,
            }
            // console.log("************handleReasonList************ ", body)
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        // console.log("************handleReasonList************ ", response.data.data)
                        setReasonList(response.data.data)

                    }
                    else if (response.data.statusCode === 1) {
                    }


                    else {


                        showToast(response.data.msg, 3000, "red");
                        // console.log(" companyWiseDeviceList error: ", response.data.msg);
                    }

                    // setLoading (false);
                }


                else if (response.status == 403) {
                    navigate("/");
                }

            }).catch(error => {
                console.log("error: ", error);
                if (error.response.status == 403) {
                    navigate("/");
                }
                // Alert.alert("ERROR")

                showToast("Slow or no internet connected. Please check your internet", 3000, "red");

                return
            })
        } catch (error) {
            console.log("error1 ", error)
            showToast("Slow or no internet connected. Please check your internet", 3000, "red");
            return
        }
    }

    const productWiseLogList = async () => {
        try {
            // console.log('*********** productWiseLogList ***********');


            let url = process.env.REACT_APP_BASE_URL + '/shift/fetchMachineProductPart';
            let body = {
                machine_id: Logs.machine_id,
                shift_id: shiftValue.current ?? undefined,
                cDate: moment(date1.current).format("YYYY-MM-DD")
            };

            // console.log(' machineHours body', body);
            await axios
                .post(url, body, {
                    headers: {
                        authorization: `${userDetails.access_token}`,
                    },
                })
                .then(response => {
                    if (response.status === 200) {

                        if (response.data.statusCode === 0) {
                            setProductWiseLog(response.data.list)
                            if (response.data.list.length) {
                                setProduct({ part: response.data.list[response.data.list.length - 1].product_name });
                                const selectedCategory = prodCategoryList.current.find(option => option.product_type == response.data.list[response.data.list.length - 1].product_type)
                                console.log("machineHours", prodCategoryList.current, response.data.list[response.data.list.length - 1].product_type);
                                console.log(selectedCategory)
                                setProdCategory(selectedCategory.id)
                            }
                        }
                        else {
                            // console.log("fetchHourList error", response.data.msg)
                            // showToast(response.data.msg, 3000, "red");
                            setProductWiseLog([])
                            return;
                        }
                    }
                })
                .catch(error => {
                    console.log(error)
                    // if (error.response.status == 403) {
                    //     navigate("/");
                    // }

                    showToast("Error", 3000, "red");
                    // return;
                });

        } catch (error) {
            console.log('error ', error);
            throw error;
        }

    }

    const receiveDataFromChild = (data) => {
        // Do something with the data received from the child component
        // console.log('Data received from child:', data);
        setOpen(false);
    };

    const navbarRender = (data) => {
        // console.log('Data received from child:', data);
        setTest(!test)
    };

    const catrgoryList = async () => {
        try {

            let url = process.env.REACT_APP_BASE_URL + "/ws/listOfProductCategory";
            let body = {
                comp_num: userDetails.comp_num,
                machine_id: Logs.machine_id
            }
            // console.log("************companyWiseDeviceList************ ", body)
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {

                        console.log("************setCategoryList************ ", response.data)
                        prodCategoryList.current = response.data.list;

                    }
                    else if (response.data.statusCode === 1) {
                        // showToast(response.data.msg, 3000, "red");
                        console.log("************setCategoryList************ ", response.data.msg)
                    }


                    else {

                        showToast(response.data.msg, 3000, "red");
                        console.log(" companyWiseDeviceList error: ", response.data.msg);
                    }

                    // setLoading (false);
                }

            }).catch(error => {
                console.log("error: ", error);
                showToast("Slow or no internet connected. Please check your internet connection.", 3000, "red");

                // Alert.alert("ERROR")

                return
            })
        } catch (error) {
            console.log("error1 ", error)
            showToast(error, 3000, "red");
            return
        }
    }
    const handleCategoryChange = (selectedId) => {
        console.log("handleCategoryChange ", selectedId)
        setProdCategory((prev) => {
            return selectedId;
        });
        handleproductList(selectedId);
    };


    React.useEffect(() => {
        const fetchData = async () => {
            machine_Data();
            machineHours();
            handleReasonList();
            await catrgoryList()
            await handleproductList(undefined);
            await productWiseLogList();
        };

        fetchData();
    }, []);

    return (
        <div className='main'>

            <div>
                {userDetails.role_id == "A" ?
                    <Navbar /> : <></>}
            </div>

            <div className='Admin_menu'>
                <Header show={1} sendNavbarToParent={navbarRender} />

                <div>
                    <div style={{ display: "inline-flex", width: "100%", alignItems: "center", }}>
                        <h3 style={{ width: "90%", textAlign: "center", color: "rgb(5, 19, 120)", margin: 5 }}>Machine Details</h3>
                        <div className='excel' style={{ backgroundColor: "whitesmoke", padding: "10px 15px", borderRadius: "50%", border: "1px solid gray", textAlign: "end" }}>
                            <i className="fa fa-file-excel-o" onClick={() => setOpen(true)}></i>
                        </div>
                    </div>
                    <div className='block1'>

                        <div className='cardStyle'>
                            <div className='row' style={{ backgroundColor: backColor(On_Time.efficiency, Logs.sensor_data.alarm_color) }}>
                                <div className='device_name'>
                                    <h3>{Logs.sensor_name}</h3>
                                    <h4>{Logs.device_name}</h4>
                                </div>
                                <div style={{ justifyContent: "space-between" }} className='inLine'>
                                    <h3 className='machineTimeText'>{On_Time.on_time}</h3>

                                    <h4 style={{
                                        width: "40%", flexWrap: 'wrap',
                                        display: (On_Time.counter_flag === "Y" ? "block" : "none")
                                    }} className='machineTimeText1'>{On_Time.sensor_count} {On_Time.counter_unit}</h4>

                                    <h4 className='machineEff'>
                                        {On_Time.efficiency}%
                                    </h4>

                                </div>


                            </div>
                        </div>

                        <div className='cardStyle'>
                            <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>

                                <div style={{ display: 'flex', alignItems: "center", width: "45%" }}>

                                    <i className="fa fa-calendar" style={{ marginRight: 10 }}></i>
                                    <DatePicker
                                        style={{ minWidth: 100, width: 200, }}
                                        selected={date}
                                        // onSelect={handleDateSelect}
                                        onChange={handleDateChange}
                                        dateFormat="YYYY/MM/dd"
                                        maxDate={new Date()}
                                    />
                                </div>

                                <div style={{ minWidth: 100, width: 200, display: 'flex', alignItems: "center" }}>
                                    <i className="fa fa-clock" style={{ marginRight: 10 }}></i>
                                    <select
                                        name="shiftTime"
                                        value={shiftTime}
                                        onChange={handleChange}
                                    >
                                        <option value="" disabled defaultValue hidden>Select Shift Time</option>
                                        {options.map((option, index) => (
                                            <option key={index} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}

                                    </select>
                                </div>
                            </div>

                            {/* <div className='showdateBlock'>
                                <h5>{date}</h5>
                                <h5>From : {from}</h5>
                                <h5>To : {to}</h5>
                            </div> */}
                            <div>
                                {shiftChangeFlag == false && prodCategoryList.current.length ?
                                    <div>
                                        <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%", marginTop: 3 }}>
                                            <h5 style={{ fontSize: 15, margin: "5px 0" }}>Product Category</h5>
                                            <div style={{ width: "60%" }}>
                                                <select
                                                    className="custom-dropdown"
                                                    name="ProductItem"
                                                    value={prodCategory}
                                                    onChange={(e) => handleCategoryChange(e.target.value)}
                                                >
                                                    <option value="" disabled hidden>
                                                        Select Category
                                                    </option>
                                                    {prodCategoryList.current.map((option, index) => (
                                                        <option key={index} value={option.id}>
                                                            {option.product_type}
                                                        </option>
                                                    ))}
                                                </select>

                                            </div>
                                        </div>
                                        <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                            <h5 style={{ fontSize: 15, margin: "5px 0" }}>Active Product</h5>
                                            <div style={{ width: "60%" }}>
                                                <select
                                                    className="custom-dropdown"
                                                    name="ProductItem"
                                                    value={product.part}
                                                    // placeholder="Select Product"
                                                    onChange={handleProduct}
                                                >
                                                    <option value=" " defaultValue hidden >{product.part ?? On_Time.product}</option>
                                                    {productoptions.map((option, index) => (
                                                        <option key={index} value={option.id}>
                                                            {option.part}
                                                        </option>
                                                    ))}

                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                    :
                                    <></>
                                }
                            </div>
                        </div>

                    </div>

                    <div className='flex-evenly-center'>
                        <div className = "log_data">
                            <div className='hourData'>
                                <h2 style={{ fontSize: 18, color: '#000000', textAlign: 'center' }}>Hourly Data</h2>
                                {/* {List === 1 ? (
                                    <i className="fa fa-chevron-up" style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} onClick={() => setList(0)} />
                                ) : (
                                    <i className="fa fa-chevron-down" style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} onClick={() => setList(1)} />
                                )} */}
                            </div>

                            <div className='custom-scroll-box'>{hourData.length !== 0 ?
                                <div className='hourRow'>
                                    <h4 style={{ width: "30%", borderRadius: 10 }}>Slot</h4>
                                    <h4 style={{ width: "30%" }}>Run Time</h4>
                                    <h4 style={{ width: "20%", display: (On_Time.counter_flag == "Y" ? "block" : "none") }}>Count</h4>
                                    <h4 style={{ width: "20%" }}>Run %</h4>
                                </div>
                                : <></>}
                                <div className='hourRow1'>
                                    {hourData.length !== 0 ? hourData.map((item, index) => (
                                        <div key={index}
                                            style={{
                                                backgroundColor: item.percentage_of_total > 60 ? (item.percentage_of_total > 80 ? "#caffbf" : "#fdffb6") : "#ffadad",
                                            }}
                                            className='table-data'
                                        >
                                            <h4 style={{ width: "30%" }}>{item.time_range}</h4>
                                            <h4 style={{ width: "30%" }}>{item.on_time}</h4>
                                            <h4 style={{ width: "20%", display: (On_Time.counter_flag == "Y" ? "block" : "none") }}>{item.sensor_count1}</h4>
                                            <h4 style={{ width: "20%" }}>{item.percentage_of_total}</h4>
                                        </div>
                                    )) : <div><h4>Hourly Data Not Present</h4> </div>}
                                </div>
                            </div>
                        </div>
                        <div className = "log_data">

                            <div className='hourData'>
                                <h2 style={{ fontSize: 18, color: '#000000', textAlign: 'center' }}>Machine Halts</h2>
                                {/* {List === 2 ? (
                                    <i className="fa fa-chevron-up" style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} onClick={() => setList(0)} />
                                ) : (
                                    <i className="fa fa-chevron-down" style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} onClick={() => setList(2)} />
                                )} */}
                            </div>

                            <div className='custom-scroll-box'>{machineHalts.length !== 0 ?
                                <div className='hourRow'>
                                    <h4 style={{ width: "10%" }}>Sno.</h4>
                                    <h4 style={{ width: "20%" }}>From</h4>
                                    <h4 style={{ width: "20%" }}>To</h4>
                                    <h4 style={{ width: "20%" }}>Time</h4>
                                    <h4 style={{ width: "30%" }}>Reason</h4>
                                </div>
                                : <></>}
                                <div className='hourRow1'>
                                    {machineHalts.length !== 0 ? machineHalts.map((item, index) => (
                                        <div key={index}
                                             className='table-data'
                                        >
                                            <h4 style={{ width: "10%" }}>{index + 1}</h4>
                                            <h4 style={{ width: "20%" }}>{item.start_time.substr(11, 5)}</h4>
                                            <h4 style={{ width: "20%" }}>{item.end_time.substr(11, 5)}</h4>
                                            <h4 style={{ width: "20%" }}>{item.Duration.substr(0, 5)}</h4>
                                            {reasonLoading == true ? <Dots /> :
                                                <select style={{ width: "30%", backgroundColor: "#e1e9f2", border: 'none', color: "gray", margin: 0 }}
                                                    className="inputField"
                                                    name="reason" // Matches the key in the `reason` object
                                                    value={item.halt_reason || ""} // Access the `reason` key of the state
                                                    onChange={halt_item => {
                                                        handleReason(item.id, halt_item)
                                                    }}
                                                >
                                                    <option value="" disabled>
                                                        Select a reason
                                                    </option>
                                                    {reasonList.map((reasonItem) => (
                                                        <option key={reasonItem.id} value={reasonItem.reason}>
                                                            {reasonItem.reason}
                                                        </option>
                                                    ))}
                                                </select>
                                            }
                                        </div>
                                    )) : <div><h4>Hourly Data Not Present</h4></div>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='flex-evenly-center'>
                        <div className = "log_data">
                            <div className='hourData'>
                                <h2 style={{ fontSize: 18, color: '#000000', textAlign: 'center' }}>Machine Free Load</h2>
                                {/* {List === 3 ? (
                                    <i className="fa fa-chevron-up" style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} onClick={() => setList(0)} />
                                ) : (
                                    <i className="fa fa-chevron-down" style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} onClick={() => setList(3)} />
                                )} */}
                            </div>

                            <div className='custom-scroll-box'>{machineFreeHalts.length !== 0 ?
                                <div className='hourRow'>
                                    <h4 style={{ width: "20%" }}>Sno.</h4>
                                    <h4 style={{ width: "30%" }}>From</h4>
                                    <h4 style={{ width: "30%" }}>To</h4>
                                    <h4 style={{ width: "20%" }}>Run Time</h4>
                                </div> : <></>}
                                <div className='hourRow1'>

                                    {machineFreeHalts.length !== 0 ? machineFreeHalts.map((item, index) => (
                                        <div key={index}
                                            className='table-data'
                                        >
                                            <h4 style={{ width: "20%" }}>{index + 1}</h4>
                                            <h4 style={{ width: "30%" }}>{item.start_time.substr(11, 5)}</h4>
                                            <h4 style={{ width: "30%" }}>{item.end_time.substr(11, 5)}</h4>
                                            <h4 style={{ width: "20%" }}>{item.Duration.substr(0, 5)}</h4>
                                        </div>
                                    )) : <div> <h4>Machine Free Load Not Present</h4> </div>}
                                </div>
                            </div>
                        </div>
                        <div className = "log_data">
                            <div className='hourData'>
                                <h2 style={{ fontSize: 18, color: '#000000', textAlign: 'center' }}>Product Wise List</h2>
                                {/* {List === 4 ? (
                                    <i className="fa fa-chevron-up" style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} onClick={() => setList(0)} />
                                ) : (
                                    <i className="fa fa-chevron-down" style={{ fontSize: 20, color: '#888', cursor: 'pointer' }} onClick={() => setList(4)} />
                                )} */}
                            </div>

                            <div className='custom-scroll-box'>{productWiseLog.length !== 0 ?
                                <div className='hourRow'>
                                    <h4 style={{ width: "30%" }}>Products</h4>
                                    <h4 style={{ width: "30%" }}>Products Category</h4>
                                    <h4 style={{ width: "20%", display: (On_Time.counter_flag == "Y" ? "block" : "none") }}>Count</h4>
                                    <h4 style={{ width: "20%" }}>Run Time</h4>
                                </div> : <></>}
                                <div className='hourRow1'>

                                    {productWiseLog.length !== 0 ? productWiseLog.map((item, index) => (
                                        <div key={index}
                                            className='table-data'
                                        >
                                            <h4 style={{ width: "30%" }}>{item.product_name}</h4>
                                            <h4 style={{ width: "30%" }}>{item.product_type}</h4>
                                            <h4 style={{ width: "20%", display: (On_Time.counter_flag == "Y" ? "block" : "none") }}>{item.product_count}</h4>
                                            <h4 style={{ width: "20%" }}>{item.on_time}</h4>
                                        </div>
                                    )) : <div> <h4>Products details not found</h4> </div>}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <Modal isOpen={open}>
                    <div>
                        <div className='report_download'>
                            <h3>Report Download</h3>
                            <i className="fa-solid fa-xmark" onClick={() => setOpen(false)}></i>
                        </div>
                        <Report show={0} deviceData={Logs} sendDataToParent={receiveDataFromChild} />
                    </div>
                </Modal>


            </div>
        </div >
    )
}

export default MachineLogs